
    <main class="page landing-page">
        <section  id="hero" class="clean-block clean-hero" style="background-image:url(&quot;assets/img/tech/image4.jpg&quot;);color:rgba(51, 140, 196, 0.55);">
            <div class="text containe">
               
                <div class="hero-container" data-aos="fade-up">
                    <h1>Oxygeni</h1>
                    <h2 style="color: rgb(252, 252, 252);">                أوكسيجاني هوا سيت تلقا والا تحط  فيه ماكينة توليد الأكسجين في ولايات تونس لكل ماعليك كان تختار البلاصة متاعك <br>وربي يشفي كل مريض
                    </h2>
                    <div style="font-size: 20px;">
                    <button  routerLink="/chercher" class="btn btn-primary" >نلوج على ماكينة توليد الأكسجين</button>

                   <br><br>
                   <button style="margin: 10px;"  routerLink="/ajouter" class="btn btn-primary" >بش نحط ماكينة توليد الأكسجين</button>
                </div>
                  </div>
            </div>
        </section>
     
     </main>
    
    